import React, { Component } from 'react';
import Spin from '../spin';
import exception from './exception';
const asyncComponent = (importComponent) => {
    class AsyncComponent extends Component {
        constructor() {
            super(...arguments);
            this.state = {};
        }
        componentDidMount() {
            importComponent().then(({ default: component }) => {
                this.setState({ component });
            }, exception);
        }
        render() {
            const { component: Cmp } = this.state;
            return Cmp
                ? React.createElement(Cmp, Object.assign({}, this.props))
                : React.createElement(Spin, null);
        }
    }
    return AsyncComponent;
};
export default asyncComponent;
